import { apiSlice } from "../apiSlice";

export interface initialData {
    home: {
        topBanner: {
            imageUrl: string;
            textOverlay: {
                title: string;
                description: string;
            };
        };
        sliderProducts: {
           itemId: string;
           itemType: string;
        }[];
        signatureDishes: {
            displayName: string;
            productId: string;
            price: string;
            description: string;
            imageUrl: string;
            id: string;
            itemType: string;
        }[];
        userReviews: {
            title: string;
            rating: number;
            review: string;
            displayName: string;            
        }[];
    },
    promise: {
        topBanner: {
            imageUrl: string;
            textOverlay: {
                title: string;
                description: string;
            };
        };
        introVideo: string;
    },
    contactInfo: {
        email: string;
        phoneNumber: string;
    }
    menu: {
        specialdishes: [
            {
                displayName: string,
                description: string,
                imageUrl: string,
                id: string,
            }
        ],
        introVideo: string,
        quickOrder: {
            displayName: string,
            description: string,
            imageUrl: string,
            id: string,
            nutrients: {
                calories: number,
                protein: number,
                carbs: number,
                fat: number
            }
        }
    }
};

const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export interface userReviewsInterface {
    title: string;
    rating: number;
    review: string;
    displayName: string;            
}


export const initialDataService = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getInitialData: builder.query<initialData, void>({
            query: () => ({
                url: `https://customersitehttps-loadinitialdata-${API_BASE_DOMAIN}-uc.a.run.app/`,
                method: "GET",
            }),
        }),
    }),
});

export const { useGetInitialDataQuery, useLazyGetInitialDataQuery } = initialDataService;